





























































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { onlyFloat, maskMoney } from '@/utils/common'

@Component
export default class ComponenteBackofficeMateriaisCotados extends Vue {
  @Prop({ default: false, required: false }) qtdeAutorizada: boolean
  @Prop({ default: false, required: false }) campoCotacao: boolean
  @Prop({ default: false, required: false }) autorizacao: boolean
  @Prop({ default: false, required: false }) autorizacaoDisabled: boolean
  @Prop({ default: false, required: false }) comentarios: boolean
  @Prop({ default: false, required: false }) comentariosDisabled: boolean
  @Prop({ default: false, required: false }) readOnly: boolean

  $refs!: {
    quantidadeAutorizada: any,
  }

  get getConfiguracaoOpme() {
    const { configuracaoOpme } = this.getBackofficeGlobalStore.solicitacao
    return configuracaoOpme
  }

  valorUnitarioRules: any = {
    valid: true,
    valorUnitario: [v => this.validarValorUnitario(v) || 'Campo obrigatório'],
  }

  validarValorUnitario(value) {
    if (['EmAutorizacao', 'AguardandoSuprimentos'].includes(this.getBackofficeGlobalStore.solicitacao.situacao.key)) return true
    return parseFloat(value) > 0
  }

  isStatusAguardandoOperadoraAutorizada(authorizedValue) {
    return this.getBackofficeGlobalStore.solicitacao.statusAguardandoOperadora === 'Autorizada'
      ? authorizedValue
      : 0
  }

  autorizacaoSelect: any[] = [
    { value: 'Autorizado', description: 'Autorizado' },
    { value: 'JustificarEmConta', description: 'Justificar em conta' },
    { value: 'NaoAutorizado', description: 'Não autorizado' },
    { value: 'NegociacaoParticular', description: 'Negociação Particular' },
  ]

  dial: boolean = false
  dialModel: string | null | undefined = ''
  get dialog() { return this.dial }
  set dialog(value: boolean) { this.dial = value }
  get dialogModel() { return this.dialModel }
  set dialogModel(value: any) { this.dialModel = value }

  setDialog(model: any) {
    this.dialogModel = model
    this.dialog = true
  }

  closeDialog() {
    this.dialog = false
  }

  total(valor: number, qtde: any) {
    const val: any = [0, '', null, undefined].includes(valor) ? 0 : Number(valor)
    const qtd: any = [0, '', null, undefined].includes(valor) ? 0 : Number(qtde)
    return val * qtd
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get materiaisCotadosOpme() {
    return this.getBackofficeGlobalStore.solicitacao.materiaisCotadosOpme
      ? this.getBackofficeGlobalStore.solicitacao.materiaisCotadosOpme
      : { materiaisCotados: [], materiaisEstoque: [] }
  }

  get materiaisCotados() {
    const { materiaisCotadosOpme } = this
    return materiaisCotadosOpme && materiaisCotadosOpme.materiaisCotados && materiaisCotadosOpme.materiaisCotados.length > 0
      ? materiaisCotadosOpme.materiaisCotados
      : []
  }

  get materiaisEstoque() {
    const { materiaisCotadosOpme } = this
    return materiaisCotadosOpme && materiaisCotadosOpme.materiaisEstoque && materiaisCotadosOpme.materiaisEstoque.length > 0
      ? materiaisCotadosOpme.materiaisEstoque
      : []
  }

  maskMoneyUtil(value) {
    return maskMoney(value)
  }

  onlyFloatUtil(value) {
    return onlyFloat(value)
  }

  isQuantidadeAutorizadaValid() {
    const isValid = !this.$refs.quantidadeAutorizada.some(c => c.validate() === false)
    return isValid
  }
}
